<template>
    <v-tab-item :value="$route.path" class="pa-3">
        <v-toolbar flat height="90">
            <v-btn
                :disabled="!getPermission('subscriptions.plans.create')"
                color="secondary"
                class="text-capitalize px-5"
                depressed
                v-text="translations.addRegistrationPlan[lang]"
                @click="open('create', {})"
            ></v-btn>

            <v-btn
                v-if="company.is_roadcube"
                color="secondary"
                class="text-capitalize px-5 ml-4"
                depressed
                v-text="translations.addCompanySubscriptionPlan[lang]"
                @click="openCompany('create', {})"
            ></v-btn>

            <v-spacer></v-spacer>

            <v-col cols="12" sm="4" class="pa-0">
                <b-search-field v-model="search"></b-search-field>
            </v-col>
        </v-toolbar>

        <v-sheet outlined style="overflow: auto">
            <v-sheet min-width="1400">
                <v-data-table
                    :headers="headers"
                    :items="registrationPlans"
                    :footer-props="{
                        itemsPerPageOptions: [12],
                        showCurrentPage: true,
                        pageText: `${page * 12 - 11}-${
                            page * 12 <= serverItemsLength
                                ? page * 12
                                : serverItemsLength
                        } ${
                            translations.paginationText[lang]
                        } ${serverItemsLength}`,
                    }"
                    :page.sync="page"
                    :server-items-length="serverItemsLength"
                    :loading="loading"
                    disable-sort
                    class="b-outlined"
                >
                    <template v-slot:item.plan_price="{ item }">
                        <span>
                            <v-icon
                                small
                                v-text="icons.mdiCurrencyEur"
                            ></v-icon>
                            {{ item.plan_price }}
                        </span>
                    </template>

                    <template v-slot:item.plan_minimum_price="{ item }">
                        <span>
                            <v-icon
                                small
                                v-text="icons.mdiCurrencyEur"
                            ></v-icon>
                            {{ item.plan_minimum_price }}
                        </span>
                    </template>

                    <template v-slot:item.ratio="{ item }">
                        <span
                            v-if="
                                item.system_subscription_plan_payment_type
                                    .system_subscription_plan_payment_type_id ==
                                    1 ||
                                item.system_subscription_plan_type.system ==
                                    'fixed'
                            "
                        >
                            <v-icon
                                small
                                v-text="icons.mdiCurrencyEur"
                            ></v-icon>
                            {{ item.ratio }}
                        </span>
                        <span
                            v-else-if="
                                item.system_subscription_plan_payment_type
                                    .system_subscription_plan_payment_type_id ==
                                    2 ||
                                item.system_subscription_plan_type.system ==
                                    'percentage'
                            "
                        >
                            <v-icon small v-text="icons.mdiPercent"></v-icon>
                            {{ item.ratio }}
                        </span>
                        <span v-else> - </span>
                    </template>

                    <template v-slot:item.extra_properties="{ item }">
                        {{ item.extra_properties.is_pos ? "Pos" : "" }}
                    </template>

                    <template v-slot:item.public="{ item }">
                        <v-icon
                            v-if="item.is_public"
                            color="green"
                            v-text="icons.mdiCheckCircleOutline"
                        ></v-icon>
                        <v-icon
                            v-else
                            color="red"
                            v-text="icons.mdiMinusCircleOutline"
                        ></v-icon>
                    </template>

                    <template v-slot:item.actions="{ item }">
                        <v-tooltip color="secondary" top>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                :disabled="!getPermission('subscriptions.plans.update')"
                                    color="yellow darken-3"
                                    icon
                                    v-on="on"
                                    @click="
                                        item.extra_properties.is_brand
                                            ? openCompany('update', item)
                                            : open('update', item)
                                    "
                                >
                                    <v-icon
                                        v-text="icons.mdiPencilOutline"
                                    ></v-icon>
                                </v-btn>
                            </template>

                            <span
                                class="font-weight-bold"
                                v-text="translations.update[lang]"
                            ></span>
                        </v-tooltip>

                        <v-tooltip color="secondary" top>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                :disabled="!getPermission('subscriptions.plans.delete')"
                                    color="red"
                                    icon
                                    v-on="on"
                                    @click="
                                        () => {
                                            deleteDialog = true;
                                            deletingItemId =
                                                item.store_subscription_plan_id;
                                        }
                                    "
                                >
                                    <v-icon v-text="icons.mdiClose"></v-icon>
                                </v-btn>
                            </template>

                            <span
                                class="font-weight-bold"
                                v-text="translations.delete[lang]"
                            ></span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-sheet>
        </v-sheet>

        <v-dialog v-model="dialog" max-width="600">
            <SubscriptionPlanForm :mode="mode" @cancel="dialog = false" />
        </v-dialog>

        <v-dialog v-model="companyDialog" max-width="600">
            <CompanySubscriptionPlanForm
                :mode="companyMode"
                @cancel="companyDialog = false"
            />
        </v-dialog>

        <v-dialog v-model="deleteDialog" max-width="500">
            <b-card
                type="delete"
                title="Delete Registration Plan"
                :loading="loading"
                :error-message="errorMessage"
                :submit-text="{ el: '', en: 'delete', it: '' }"
                @cancel="deleteDialog = false"
                @submit="removeRegistrationPlan(deletingItemId)"
            >
                <div class="subtitle-1 font-weight-medium pl-2">
                    Are you sure you want to delete
                    <span class="font-weight-bold text--primary"
                        >Registration Plan</span
                    >?
                </div>
            </b-card>
        </v-dialog>
    </v-tab-item>
</template>

<script>
import translations from "@/utils/translations/loyaltyPanel/subscriptions/registrationPlans";
import { mapState, mapMutations, mapActions } from "vuex";
import SubscriptionPlanForm from "@/components/loyaltyPanel/subscriptions/registrationPlans/SubscriptionPlanForm.vue";
import CompanySubscriptionPlanForm from "@/components/loyaltyPanel/subscriptions/registrationPlans/CompanySubscriptionPlanForm.vue";
import {
    mdiCheckCircleOutline,
    mdiMinusCircleOutline,
    mdiPercent,
    mdiOfficeBuildingOutline,
    mdiClose,
    mdiPencilOutline,
    mdiEye,
    mdiCurrencyEur,
} from "@mdi/js";
import debounce from "lodash/debounce";

export default {
    name: "Pending",

    mixins: [translations],

    components: { SubscriptionPlanForm, CompanySubscriptionPlanForm },

    data() {
        return {
            itemsPerPageOptions: [10, 20, 30, -1],
            icons: {
                mdiCurrencyEur,
                mdiPercent,
                mdiCheckCircleOutline,
                mdiMinusCircleOutline,
                mdiOfficeBuildingOutline,
                mdiClose,
                mdiPencilOutline,
                mdiEye,
            },
            deletingItemId: "",
            mode: 'create',
            companyMode: 'create',
            page: +this.$route.query.page,
            search: "",
        };
    },

    computed: {
        ...mapState(["loading", "errorMessage", "serverItemsLength"]),
        ...mapState("loyaltyPanel", ["company"]),
        ...mapState("loyaltyPanel/subscriptions/registrationPlans", [
            "registrationPlans",
        ]),

        lang() {
            return this.$route.params.lang;
        },

        dialog: {
            get() {
                return this.$store.state.dialog;
            },

            set(val) {
                this.setDialog(val);
            },
        },

        deleteDialog: {
            get() {
                return this.$store.state.deleteDialog;
            },

            set(val) {
                this.setDeleteDialog(val);
            },
        },

        subscriptionPlan: {
            get() {
                return this.$store.state.loyaltyPanel.subscriptions
                    .registrationPlans.subscriptionPlan;
            },

            set(val) {
                this.setSubscriptionPlan(val);
            },
        },

        companySubscriptionPlan: {
            get() {
                return this.$store.state.loyaltyPanel.subscriptions
                    .registrationPlans.companySubscriptionPlan;
            },

            set(val) {
                this.setCompanySubscriptionPlan(val);
            },
        },

        companyDialog: {
            get() {
                return this.$store.state.loyaltyPanel.subscriptions
                    .registrationPlans.companyDialog;
            },

            set(val) {
                this.setCompanyDialog(val);
            },
        },

        query() {
            let query = "?";

            for (let key in this.$route.query) {
                query += `${key}=${this.$route.query[key]}&`;
            }

            return query.slice(0, query.length - 1);
        },

        headers() {
            return [
                {
                    text: this.translations.name[this.lang],
                    value: `plan_name[${this.lang}]`,
                },
                {
                    text: this.translations.description[this.lang],
                    value: `plan_description[${this.lang}]`,
                },
                {
                    text: this.translations.extra_properties[this.lang],
                    value: "extra_properties",
                },
                {
                    text: this.translations.price[this.lang],
                    value: "plan_price",
                    width: 150,
                },
                {
                    text: this.translations.reward_points[this.lang],
                    value: "reward_points",
                },
                {
                    text: this.translations.reward_type[this.lang],
                    value: "reward_type.title",
                },
                {
                    text: this.translations.public[this.lang],
                    value: "public",
                },
                {
                    text: this.translations.actions[this.lang],
                    value: "actions",
                },
            ];
        },
    },
    methods: {
        ...mapMutations([
            "setDialog",
            "setDeleteDialog",
            "setResetSuccess",
            "setResetValidation",
        ]),
        ...mapMutations("loyaltyPanel/subscriptions/registrationPlans", [
            "setSubscriptionPlan",
            "setCompanySubscriptionPlan",
            "setCompanyDialog",
        ]),
        ...mapActions("loyaltyPanel/subscriptions/registrationPlans", [
            "getRegistrationPlans",
            "removeRegistrationPlan",
            "getPlanProfile",
            "getRegistrationPlanProfile",
        ]),
        ...mapActions(["getPermission"]),

        handleSearch() {
            this.getRegistrationPlans(`?q=${this.search}`);
        },

        open(mode, item) {
            this.mode = mode;
            if (mode == 'create') {
                this.subscriptionPlan = {};
                this.dialog = true;
            } else {
                this.getRegistrationPlanProfile(
                    item.store_subscription_plan_id
                );
            }

            setTimeout(() => this.setResetSuccess(true), 300);
            this.setResetValidation(true);
        },

        openCompany(mode, item) {
            this.companyMode = mode;
            if (mode == 'create') {
                this.companySubscriptionPlan = {};
                this.companyDialog = true;
            } else {
                this.getRegistrationPlanProfile(
                    item.store_subscription_plan_id
                );
            }

            setTimeout(() => this.setResetSuccess(true), 300);
            this.setResetValidation(true);
        },
    },
    watch: {
        $route(val) {
            if (!val.query.page) {
                this.$router.push({
                    query: {
                        page: 1,
                        ...this.$route.query,
                    },
                });
            }
            this.getRegistrationPlans(this.query);
        },

        page(page) {
            this.$router.push({ query: { ...this.$route.query, page } });
        },

        search(val) {
            if (val == null) {
                this.getRegistrationPlans(this.query);
            } else {
                this.debouncedSearch();
            }
        },
    },
    mounted() {
        this.getRegistrationPlans(this.query);
    },
    created() {
        this.debouncedSearch = debounce(this.handleSearch, 500);
    },
    beforeCreate() {
        if (!this.$route.query.page) {
            this.$router.push({
                query: {
                    page: 1,
                    ...this.$route.query,
                },
            });
        }
    },
};
</script>
